export const rootImageUrl = 'https://ik.imagekit.io/tonkec/images/'
